import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeScreenComponent } from './home.component';
import { StoreModule } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CCMSTableComponent } from 'src/commons/components/ccms-table/ccms-table.component';
import { CCMSTableExtComponent } from 'src/commons/components/ccms-table-ext/ccms-table-ext.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { reducers } from './state/home.selectors';
import { AppCommonModule } from 'src/app/common.module';


@NgModule({
  imports: [    
    CommonModule,
    ReactiveFormsModule,
    AppCommonModule,
    StoreModule.forFeature('home', reducers)
  ],
  declarations: [],
})
export class HomeScreenModule { }